module.exports = __webpack_public_path__ + "img/shebeistatus4.b694aa4d.jpg";